import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
  DatePicker,
  Dropdown,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  BarsOutlined,
  RedoOutlined,
  MoreOutlined,
  MedicineBoxOutlined,
  FileDoneOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { ItemList } from "../../../components/itemList";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Finalizado" },
  { value: 1, label: "Ativo" },
  { value: -1, label: "Inativo" },
];

const array_status = {
  "0": "Finalizado",
  "1": "Ativo",
  "-1": "Inativo",
};

export const CampanhasVacinacaoCadastro = ({ to }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    listarCampanhas();
  }, []);

  // LISTAR
  const listarCampanhas = async () => {
    setLoading(true);
    const api = await http("get", `v1/campanhas_vacinacao/listar`, []);
    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarCampanha = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/campanhas_vacinacao/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "ADD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarCampanha = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/campanhas_vacinacao/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarCampanha = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/campanhas_vacinacao/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        titulo_campanha: api.response.data.titulo_campanha,
        observacoes_campanha: api.response.data.observacoes_campanha,
        ano: api.response.data.ano,
        data_inicio: dayjs(api.response.data.data_inicio),
        data_fim: dayjs(api.response.data.data_fim),
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarCampanha = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/campanhas_vacinacao/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      dispatch({ type: "DELETE", payload: { id: id } });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // GERAR COLABORADORES
  const gerarCampanha = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/campanhas_vacinacao/gerar_campanha`, { id: id });
    if (api.statusCode === 200) {
      message.success("Campanha gerada com sucesso!");
      dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // BAIXAR CSV
  const baixarCsvConfirmados = async (idCampanha) => {
    setLoading(true);
    const api = await http("file", `v1/campanhas_vacinacao_lancamento/gerar-csv/${idCampanha}`, []);

    if (api.statusCode === 200) {
      const blob = new Blob([api.response.data], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", `relatorio_confirmados_campanha_${idCampanha}.csv`);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success("CSV exportado com sucesso!");
    } else {
      message.error(api.response.message);
    }

    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Título",
      dataIndex: "titulo_campanha",
    },
    {
      title: "Ano",
      dataIndex: "ano",
    },
    {
      title: "Data Início",
      dataIndex: "data_inicio",
      render: (_, e) => dayjs(e.data_inicio).format("DD/MM/YYYY"),
      renderText: (e) => dayjs(e.data_inicio).format("DD/MM/YYYY"),
    },
    {
      title: "Data Fim",
      dataIndex: "data_fim",
      render: (_, e) => dayjs(e.data_fim).format("DD/MM/YYYY"),
      renderText: (e) => dayjs(e.data_fim).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => array_status[e.status],
      renderText: (e) => array_status[e.status],
    },
    {
      title: "Gerado",
      dataIndex: "status_gerado",
      render: (_, e) =>
        e.status_gerado === 1 ? <Text type="success">Gerado</Text> : <Text type="danger">Não Gerado</Text>,
      renderText: (e) => (e.status_gerado === 1 ? "Gerado" : "Não Gerado"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 50,
      sorter: false,
      render: (_, e) => {
        const items = [
          e.status_gerado === 1 && {
            key: "1",
            label: "Gerar CSV",
            icon: <FilePdfOutlined />,
            onClick: () => baixarCsvConfirmados(e.id),
          },
          {
            key: "2",
            label: "Vincular Filiais",
            icon: <BarsOutlined />,
            onClick: () => navigate(`/campanhas-vacinacao/campanhas/filiais/${e?.id}`),
          },
          e.status_gerado === 1 && {
            key: "3",
            label: "Relatório de Participação",
            icon: <FileDoneOutlined />,
            onClick: () => navigate(`/campanhas-vacinacao/campanhas/colaboradores/${e?.id}`),
          },
          e.status_gerado !== 1 && e.status === 1 && {
            key: "4",
            label: "Gerar Campanha",
            icon: <RedoOutlined />,
            onClick: () => {
              modal.confirm({
                title: "Deseja gerar a campanha?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  gerarCampanha(e.id);
                },
              });
            },
          }
        ].filter(Boolean);

        return (
          <Space.Compact>
            <Dropdown menu={{ items }}>
              <Button loading={loading} icon={<MoreOutlined />} />
            </Dropdown>

            <Tooltip title="Editar">
              <Button loading={loading} onClick={() => carregarCampanha(e.id)} icon={<EditOutlined />} />
            </Tooltip>
            <Tooltip title="Excluir">
              <Button
                danger
                loading={loading}
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarCampanha(e.id);
                    },
                  });
                }}
              />
            </Tooltip>
          </Space.Compact>
        );
      },
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.data_inicio = dayjs(formulario.data_inicio).format("YYYY-MM-DD");
    formulario.data_fim = dayjs(formulario.data_fim).format("YYYY-MM-DD");

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarCampanha(formulario);
    } else {
      cadastrarCampanha(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Campanha
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1000}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item name="titulo_campanha" label="Título da Campanha" rules={[{ required: true, message: "Digite o título da campanha!" }]}>
              <Input size="large" disabled={loading} placeholder="Informe o título" />
            </Form.Item>
          </Col>
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item name="observacoes_campanha" label="Detalhes da campanha" rules={[{ required: true, message: "Digite os detalhes da campanha!" }]}>
              <TextArea size="large" disabled={loading} placeholder="Informe os detalhes da campanha" />
            </Form.Item>
          </Col>
          <Col className="gutter-row" xs={24} sm={24} md={6} lg={8} xl={8}>
            <Form.Item name="ano" label="Ano" rules={[{ required: true, message: "Digite a ano da campanha!" }]}>
              <InputNumber
                min={2026}
                className="input-number"
                max={2100}
                step={1}
                size="large"
                disabled={loading}
                placeholder="Informe o ano"
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={8} xl={8}>
            <Form.Item
              name="data_inicio"
              label="Data de Início"
              rules={[{ required: true, message: "Selecione a data de início!" }]}>
              <DatePicker 
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                size="large"
                disabled={loading}
                onChange={() => form.validateFields(["data_fim"])}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={8} xl={8}>
            <Form.Item
              name="data_fim"
              label="Data Fim"
              dependencies={["data_inicio"]}
              rules={[
                { required: true, message: "Selecione a data de término!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const inicio = getFieldValue("data_inicio");
                    if (!value || !inicio || !dayjs(value).isBefore(dayjs(inicio), "day")) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("A data fim não pode ser anterior à data início!"));
                  },
                }),
              ]}>
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                size="large"
                disabled={loading}
                disabledDate={(current) => {
                  const inicio = form.getFieldValue("data_inicio");
                  return inicio ? current && current.isBefore(dayjs(inicio), "day") : false;
                }}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={24} xl={24}>
            <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Campanhas de Vacinação" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title="Campanhas de Vacinação"
              subtitle="Cadastro de Campanhas"
              icon={<MedicineBoxOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
                expandable={{
                  expandedRowRender: (e) => (
                    <Row>
                      <Col span={24} style={{ padding: 5 }}>
                        <ItemList>
                          <Text strong>Detalhes: </Text>
                          <Text>{e.observacoes_campanha || "Sem observações"}</Text>
                        </ItemList>
                      </Col>
                    </Row>
                  )
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
